export var SetupStepType;
(function (SetupStepType) {
    SetupStepType["Responsibilities"] = "Functions";
    SetupStepType["Companies"] = "Companies";
    SetupStepType["Groups"] = "Groups";
    SetupStepType["Premises"] = "Premises";
    SetupStepType["Emails"] = "Emails";
    SetupStepType["Payment"] = "Payment";
    SetupStepType["Registrations"] = "Registrations";
})(SetupStepType || (SetupStepType = {}));
export function getSetupStepName(step) {
    switch (step) {
        case SetupStepType.Responsibilities:
            return 'functies';
        case SetupStepType.Companies:
            return 'facturatiegegevens';
        case SetupStepType.Groups:
            return 'leeftijdsgroepen';
        case SetupStepType.Premises:
            return 'lokalen';
        case SetupStepType.Emails:
            return 'e-mailadressen';
        case SetupStepType.Payment:
            return 'betaalinstellingen';
        case SetupStepType.Registrations:
            return 'inschrijvingen';
    }
}
//# sourceMappingURL=SetupStepType.js.map